import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import { IDonorProfilePreSelectLogData } from '@nkr/models/index';
import ReactLoading from 'react-loading';
import AcceptsView from '@nkr/views/donors/profile/accepts-declines/accepts-view';

interface IProps {
    show: boolean,
    rowRef: any,
    tableRef: MutableRefObject<any>,
    isAdmin?: boolean,
    data: IDonorProfilePreSelectLogData | null,
    onHide: () => void
}

const AcceptsOverlay = (props: IProps) => {
    const { show, rowRef, tableRef } = props;
    const [accepts, setAcceptsData] = useState<IDonorProfilePreSelectLogData | null>(null);
    const popoverRef = useRef(null);

    useEffect(() => {
        setAcceptsData(props.data);
    }, [props.data]);

    const logs = accepts?.preselectLogs;
    const hasData = props.data != null;
    const hasLogs = Array.isArray(logs) && logs.length > 0;

    return (
        <Overlay show={show} placement='top' target={rowRef} container={tableRef.current}>
            <Popover ref={popoverRef} id='eplet-overlay' style={{ maxWidth: '1200px', minWidth: '1200px', minHeight: '400px' }}>
                {!hasData ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '5px', marginTop: '145px' }}>
                        <ReactLoading type={'spin'} color={'black'} />
                    </div>
                    :
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ width: '10%' }}>&nbsp;</div>
                            <div style={{ width: '80%' }}>
                                <span style={{ fontSize: '22px', display: 'table', margin: '0 auto' }}>
                                    Activity Log for <b><a target={'_blank'} href={"/center/" + props.data.donorCenterId + "/donor/" + props.data.donorId + "/profile/activity"}>{props.data.donorAlias}</a></b>
                                </span>
                            </div>
                            <div style={{ width: '10%', display: 'flex', justifyContent: 'right' }}>
                                <span style={{ cursor: 'pointer' }} className={'glyphicon glyphicon-remove'} aria-hidden='true' onClick={() => props.onHide()} />&nbsp;
                            </div>
                        </div>

                        {hasLogs ? (
                            <AcceptsView data={logs} isAdmin={props.isAdmin} isCenterView={false} />
                        ) : (
                            <div style={{ textAlign: 'center', marginTop: '120px', fontSize: '16px' }}>
                                No accepts or declines to show for this donor.
                            </div>
                        )}
                    </div>
                }
            </Popover>
        </Overlay>
    );
};

export default AcceptsOverlay;
